// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__11E_Q","row":"Node_row__pP-VC","label":"Node_label__38FNL","footer":"Node_footer__3tv2H"};